"use strict";

exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/dom-helpers/ownerDocument.js
 ** module id = ./node_modules/react-bootstrap/node_modules/dom-helpers/ownerDocument.js
 ** module chunks = 0
 **/